/* @flow */
import {createAction} from 'redux-act';

import type {FilterObject} from 'nutshell-core/types';

export type CustomSegmentListRequestedAction = {
    type: 'CUSTOM_SEGMENT_LIST_DATA_REQUESTED',
    payload: {
        filters: FilterObject[],
        pageNum: number,
        columns: string[],
        sort: string,
        q: string,
    },
};

export type CustomSegmentReportDataRequestedAction = {
    type: 'CUSTOM_SEGMENT_REPORT_DATA_REQUESTED',
    payload: {
        reportParams: Object,
        filters: FilterObject[],
    },
};

export const toggleShowFilterDrawer = createAction('CUSTOM_SEGMENT_LIST_FILTER_DRAWER_TOGGLED');

// Custom segment list
export const requestCustomSegmentListData: (
    payload: $PropertyType<CustomSegmentListRequestedAction, 'payload'>
) => CustomSegmentListRequestedAction = createAction('CUSTOM_SEGMENT_LIST_DATA_REQUESTED');
export const updateCustomSegmentListData = createAction('CUSTOM_SEGMENT_LIST_DATA_UPDATED');
export const failCustomSegmentListData = createAction('CUSTOM_SEGMENT_LIST_DATA_FAILED');

// Custom segment report
// this is likely useless?
export const requestCustomSegmentReportData: (
    payload: $PropertyType<CustomSegmentReportDataRequestedAction, 'payload'>
) => CustomSegmentReportDataRequestedAction = createAction('CUSTOM_SEGMENT_REPORT_DATA_REQUESTED');
export const updateCustomSegmentReportTableData = createAction(
    'CUSTOM_SEGMENT_REPORT_TABLE_DATA_UPDATED'
);
export const updateCustomSegmentReportChartData = createAction(
    'CUSTOM_SEGMENT_REPORT_CHART_DATA_UPDATED'
);
export const updateCustomSegmentReportMaps = createAction('CUSTOM_SEGMENT_REPORT_MAPS_UPDATED');
export const failCustomSegmentReportChartData = createAction(
    'CUSTOM_SEGMENT_REPORT_CHART_DATA_FAILED'
);
